module.exports = __webpack_public_path__ + "static/media/Cactus_Flesh.01a1d638.webp";